import React,{useState,useCallback,useEffect} from 'react';
import {List,InputItem,Button} from 'antd-mobile';
import {connect} from 'dva';
import Loading from '../../Loading';
//基础信息设置
function Jcxx(props)
{
    let [AAA202,setAAA202] = useState();
    let [Email,setEmail] = useState();
    let [message,setMessage] = useState();

    useEffect(()=>{
        props.dispatch({type:"index/aa02QueryByAAA201",payload:{
            AAA201:localStorage.getItem("AAA201"),
        }}).then((res)=>{
            setAAA202(res.AAA202);
            setEmail(res.Email);
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[1]);

    const handlesubmit = useCallback(
        () => {
            if(!AAA202)
            {
                setMessage('手机号必须输入！');
                return;
            }else if(!Email){
                setMessage('邮箱必须输入！');
                return;
            }else{
                props.dispatch({type:"index/aa02XgJcxx",payload:{
                    AAA201:localStorage.getItem("AAA201"),
                    AAA202:AAA202.replace(/\s/ig,''),
                    Email
                }}).then((res)=>{
                    setMessage(res.message);
                });
            }
            
        },
        [AAA202,Email,props]
      );

    const zhma = useCallback(()=>{
        if(!AAA202)
        {
                setMessage('手机号必须输入！');
                return;
        }
        props.dispatch({type:"index/aa02zhma",payload:{
            AAA202:AAA202.replace(/\s/ig,'')
        }}).then((res)=>{
            setMessage(res.message);
        });
    },[AAA202,props]);

    return (
        <div>
          <h1>
         基础信息
         </h1>
        <List>
       
        <InputItem type="phone" value={AAA202} onChange={(value)=>setAAA202(value)} placeholder="请输入手机号..." >手机号码</InputItem>
        <InputItem type="text" value={Email} onChange={(value)=>setEmail(value)} placeholder="请输入邮箱..." >邮箱</InputItem>
        <Loading loading={props.loading} />
        </List>
        <h2> {message===""?props.message:message}</h2>
        <Button type="primary" loading={props.loading} disabled={props.loading} onClick={handlesubmit} >保存</Button>
        <br/>
        <br/>
        <br/>
        <Button type="warning" loading={props.loading} disabled={props.loading} onClick={zhma} >找回密码</Button>
 
     
    </div>
    );
}

export default connect(state=>{
    return {
        ...state.index,
        loading: state.loading.global
    }
})(Jcxx) ;